export type LazyAsync<T> = FunctionLazyAsync<T> | Promise<T> | T;
type FunctionLazyAsync<T> = () => T | Promise<T>;

export async function resolveLazyAsync<T>(input: LazyAsync<T>): Promise<T> {
  const strictValue =
    typeof input === 'function'
      ? // assumption: T is not a function
        (input as FunctionLazyAsync<T>)()
      : input;

  return await strictValue;
}
